import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { WidgetContainer } from "../components/WidgetContainer";
import MinusIcon from '../components/icons/minusIcon';
import {
    MinChatUiProvider,
    MainContainer,
    MessageContainer,
    MessageHeader,
} from "@minchat/react-chat-ui";
import MessageInput from '../components/message-input/index';
import MessageList from "../components/message/MessageList";
import { isMobile } from 'react-device-detect';
import { useChat } from "../contexts/ChatProvider";
import { useLocale } from '../contexts/LocaleProvider';
import { nanoid } from "nanoid";
import { generateUserId } from '../utils/user';

function LandingPage() {
    const {
        sendMessage,
        makeApiCall,
        setShowTypingIndicator,
        loading,
        loadConversation,
        setLoadConversation,
        header,
        greeting,
        setGreeting,
        setClientKey,
        setDataPrefix,
        setHeader,
        setUserId,
        setCustomTheme
    } = useChat();
    const { t } = useLocale();
    const [searchParams] = useSearchParams();
    const [isOpen, setOpen] = useState(false);
    const mairaLogo = process.env.REACT_APP_MAIRA_LOGO_URL ? process.env.REACT_APP_MAIRA_LOGO_URL : "https://dz91s4us75f2i.cloudfront.net/maira_advisor_256x256_666b3f0ad1.png"; 

    useEffect(() => {
        const clientKey = searchParams.get('client-key') || "E93wTC6HclocljPELpY1M-H5OpfLSC909tSB7nDO4uU=";
        setClientKey(clientKey);
        setDataPrefix("homepage");
        setHeader("Maira AI Advisor");
        setCustomTheme("#3A6D8C");
        if (!greeting) {
            setGreeting(t("landing_page.greeting_message"))
        }
        if (!loadConversation) {
            setLoadConversation(true);
        }
        const storedUserId = localStorage.getItem('homepage_userId');
        setUserId(storedUserId || generateUserId());
    }, [])

    const handleSend = (message) => {
        setShowTypingIndicator(true);
        const newMessages = [
            {
                _id: nanoid(),
                text: message,
                user: "me",
                type: "outgoing",
                createdAt: new Date(),
            },
        ];
        sendMessage(newMessages);
        makeApiCall(message).then(() => {
            setShowTypingIndicator(false);
        }).catch(err => {
            console.log(err);
            sendMessage({
                _id: nanoid(),
                text: t("chat.sending_query_error"),
                user: "me",
                type: "incoming",
                createdAt: new Date(),
            });
            setShowTypingIndicator(false);
        });
    }
    return (
        <div className='relative h-full overflow-y-scroll bg-gradient-to-r from-white to-blue-200'>
            {isOpen && isMobile &&
                <div className='h-full '>
                    <div
                        className="chatbot-container-landing-page-mobile w-full shadow-gray-400  shadow-md bg-white rounded-xl"
                    >
                        <MinChatUiProvider
                            colorSet={{}}
                        >
                            <MainContainer>
                                <MessageContainer>
                                    <MessageHeader showBack={false}>
                                        <div style={{ display: "flex", justifyContent: "space-between", padding: "0 5% 0 5%" }}>
                                            <p id="ChatBotTitle">
                                                {header}
                                            </p>
                                            <span onClick={() => { setOpen(false) }}
                                                style={{ cursor: "pointer" }}
                                            >
                                                <MinusIcon color="#000" />
                                            </span>
                                        </div>
                                    </MessageHeader>
                                    <MessageList
                                        loading={loading}
                                    >
                                    </MessageList>
                                    <MessageInput placeholder={t("chat.default_input_placeholder")}
                                        onSendMessage={handleSend}
                                        showAttachButton={false} />
                                </MessageContainer>
                            </MainContainer>
                        </MinChatUiProvider>
                    </div>
                </div>
            }
            {(!isOpen || !isMobile) && (<>
                <div
                    className="h-[92%] flex flex-col bg-gray-100 px-4 bg-gradient-to-r from-white to-blue-100"
                >
                    <div
                        className="md:flex justify-between md:h-full"
                    >
                        <div class="flex flex-col justify-between md:w-1/2 p-2 bg-transparent">
                            <div className="">
                                <span className="flex justify-start">
                                    <img
                                        src={mairaLogo}
                                        alt="AI Advisor"
                                        className="w-[64px] h-[64px] mt-6 box-border rounded-full object-cover object-top border-2 border-blue-300"
                                    />
                                    <h1 className="text-6xl font-bold pl-3 pt-6">Maira</h1>
                                </span>
                            </div>
                            <div className="lg:p-10 md: p-5 ">
                                <h1 className="lg:text-4xl text-2xl font-normal text-gray-800 pt-16 brightness-200">
                                    {t("landing_page.first_header")}
                                </h1>
                                    {t("landing_page.second_header")}
                                <h2 className="lg:text-lg text-sm text-gray-800 pr-6 pt-4 brightness-200">
                                </h2>
                                {isMobile && (
                                    <button
                                        className="text-white mt-8 font-semibold py-2 px-4 rounded-md w-full"
                                        style={{ backgroundColor: "#7aafff" }}
                                        onClick={() => { setOpen(true) }}
                                    >
                                        {t("landing_page.click_to_try")}
                                    </button>
                                )}
                            </div>
                            {!isMobile && (<div />)}{/* Need this empty div to maintain vertical spacing */}
                        </div>
                        {!isMobile && (
                            <div className="flex justify-center xl:pl-9 pt-16 md:w-1/2 p-2 bg-transparent">
                                <div
                                    className="chatbot-container-landing-page shadow-gray-400  shadow-md bg-white rounded-xl xl:w-[50%]"
                                >
                                    <MinChatUiProvider colorSet={{}}>
                                        <MainContainer>
                                            <MessageContainer>
                                                <MessageHeader showBack={false}>
                                                    <div style={{ display: "flex", justifyContent: "space-between", padding: "0 5% 0 5%" }}>
                                                        <p id="ChatBotTitle">{header}</p>
                                                    </div>
                                                </MessageHeader>
                                                <MessageList
                                                    loading={loading}
                                                >
                                                </MessageList>
                                                <MessageInput placeholder={t("chat.default_input_placeholder")}
                                                    onSendMessage={handleSend}
                                                    showAttachButton={false} />
                                            </MessageContainer>
                                        </MainContainer>
                                    </MinChatUiProvider>
                                </div>
                            </div>)}
                    </div>

                </div>
                <div class="absolute bottom-0 left-0  w-full bg-gray-800 text-white py-4">
                    <div class="flex flex-col mx-8 md:flex-row justify-between items-center">
                        <div class="text-center md:text-left mb-2 md:mb-0">
                            <p class="text-sm md:text-base">
                                Powered by <span class="font-semibold">Gigalogy Inc.</span>
                            </p>
                            <p class="text-xs text-gray-400">
                                {t("landing_page.explore_message")}
                            </p>
                        </div>

                        <div class="mt-2 md:mt-0">
                            <a href="https://gigalogy.com" target="_blank"
                                class="inline-block px-4 py-2 bg-white text-gray-900 text-sm font-medium rounded-md hover:bg-blue-100 transition">
                                {t("landing_page.visit_site")}
                            </a>
                        </div>
                    </div>
                </div>
            </>)}
        </div>
    )
}
export default LandingPage;